module.exports = __webpack_public_path__ + "4e6cfd5ae78f13c91dc57fe1683197f3.pdf";